/* eslint-disable */

// 对应 lily.params.js，一些枚举数据 最常见的是下拉列表的枚举。
import getMethods from './methods'
export default {
  install: function (Vue, options) {
    const methods = getMethods.call(Vue.prototype)
    Vue.prototype.$_params = {
      ...methods,
      //grb企业菜单后半部分
      CB_MENU_ARRAY: [{
        "id": "D",
        "label": "企业&安全",
        "children": [{
          "id": "107",
          "label": "企业安全",
          "children": [{
              "id": "10700600",
              "label": "账户限额设置",
              "action": "10700600_hangAccountMaintenance"
            },
            {
              "id": "10700500",
              "label": "企业管理授权",
              "action": "10700500_enterpriseManagementAuthorization"
            },
            {
              "id": "10700000",
              "label": "用户号维护",
              "action": "10700000_operatorMaintenance"
            },
            {
              "id": "10700800",
              "label": "密码重置审批",
              "action": "sdfsdfResetPassword"
            },
            // {"id":"10101300","label":"收款申报","action":"10101300_receiptReport"},
            // {"id":"10201100","label":"付款申报","action":"10201100_transOutReport"}
            // {"id":"20210630","label":"交易核查","action":"20210630_trialCheck"}
            // {"id":"20210803","label":"薪酬发放","action":"20210803_salary"}
          ]
        }, {
          "id": "999",
          "label": "客户服务",
          "children": [{
              "id": "99992000",
              "label": "用户操作日志查询",
              "action": "99992000_CBLOG_QUERY"
            },
            {
              "id": "10700100",
              "label": "登录密码修改",
              "action": "10700100_login_password_manage"
            },
            {
              "id": "certUpdate",
              "label": "U盾证书更新",
              "action": "certUpdate"
            },
            {
              "id": "15000100",
              "label": "地址管理",
              "action": "15000100_contact_address"
            }
            /*{"id":"bankCustomerServiceContact","label":"客服联系方式","action":"bankCustomerServiceContact"},
            {"id":"bankTelecomRegulation","label":"资费标准","action":"bankTelecomRegulation"}*/
          ]
        }]
      }],
      PB_LOAN_STATE: {
        '01': "正常",
        '04': "逾期"
      },
      //授权操作
      CB_OPERATING_TYPE: {
        'S': "提交指令",
        '00': "复核通过",
        '01': "复核拒绝",
        '10': "授权通过",
        '11': "授权拒绝",
        '20': "强制授权通过",
        '21': "强制授权拒绝",
        '5': "预约被撤销",
        '6': "撤销",
        '9': "发送",
        '92': "指令作废",
        '91': "交易被撤销"
      },
      PAYBOOK_BANK_TYPE: {
        '0': '行内',
        '1': '行外',
        '2': '行外'
      },
      //跨行转账类型
      EXTERNAL_TRANSFER_TYPE: {
        '2': '实时转账',
        '1': '快速转账',
        '0': '普通转账',
        '3': '行内转账',
        '4': '行内同名转账'
      },
      CB_AUTH_TYPE: {
        '0': "无序授权",
        '1': "有序授权"
      },
      CB_CHECK_TYPE: {
        '0': "不需要复核",
        '1': "需要1人复核",
        'x': "需要x人复核"
      },
      CERT_TYPE: {
        '0': '身份证',
        '1': '户口簿',
        '2': '护照',
        '3': '军官证',
        '4': '士兵证',
        '5': '港澳来往内地通行证',
        '6': '台湾同胞来往内地通行证',
        '7': '临时身份证',
        '8': '外国人居留证',
        '9': '警官证',
        'X': '其他证件'
      },
      /*企业证件类型增加*/
      CBCERT_TYPE: {
        'CI': '公司注册证明书',
        'BR': '商业登记证',
        'OT': '其他'
      },
      USER_INFO_STT: {
        '0': '正常',
        '1': '暂时冻结',
        '2': '冻结',
        '4': '维护中'
      },
      AUTO_TRANSFER_FLAG_TYPE: {
        '0': '是',
        '1': '否'
      },
      LoanBack: {
        '1': '是',
        '0': '否'
      },
      MANAGE_FLAG: {
        '0': '统一设置',
        '1': '分别设置'
      },
      /**
       * 陈虹林 只显示活期帐户 todo
       */
      CB_ACCOUNT_KIND: {
        'S': '标准账户',
        'MSB': '投资账户',
        'MSBC': '快速贸易账户',
        'MSBD': '电商账户',
        /*'1':'活期账号',
          '2':'定期合约',
          '3':'货款合约',
          '4':'存放同业账号'*/
      },
      /**
       *  新币种账户申请回显类型
       * */

      CB_ACCOUNT_TYPE: {
        '0': '标准收款',
        '00': '标准收款',
        'MSB': '投资收款',
        'MSBC': '贸易收款',
        'MSBD': '电商收款',
        /*'1':'活期账号',
          '2':'定期合约',
          '3':'货款合约',
          '4':'存放同业账号'*/
      },
      /**
       *  新币种账户申请类型
       * */
      CB_ACCOUNT_TYPE_OPEN: {
        '00': '标准账户',
        // 'MSB': 'B类账号',
        /*'1':'活期账号',
          '2':'定期合约',
          '3':'货款合约',
          '4':'存放同业账号'*/
      },
      /**
       *  新币种账户申请状态
       */
      ELECTRONIC_ACCOUNT_OPEN_STATE: {
        "00": "银行处理中", //"已提交",
        "01": "银行处理中", //"审核中",
        "02": "开通失败",
        "03": "开通成功",
        "04": "银行处理中", //"需补充资料"
      },
      /**
       * zhaohr 账户类型
       */
      ACCOUNT_TYPE_GRB: {
        'S': '标准账户',
        'MSB': '投资账户',
        'MSBC': '快速贸易账户',
        'MSBD': '电商账户',
        '1': '标准账户',
        '2': '定期合约',
        '3': '货款合约',
        '4': '存放同业账户'
      },
      /**
       * 收款人名册： 收款人类型
       */
      PAYEE_TYPE_GRB: {
        '0': '个人',
        '1': '企业'
      },
      ACCOUNTNO_STATE_TYPE: {
        '0': '正常',
        '1': '挂失',
        '2': '异常', //部分冻结(止付)
        '3': '异常', //全部冻结(止付)
        '4': '冻结',
        '5': '注销'
      },
      CHANNEL_TYPE: {
        '01': '网上银行',
        '02': '手机银行'
      },

      CHANNEL_FLAG: {
        '0': '网银交易',
        '1': '柜面交易'
      },
      CB_CHANGESAVE: {
        '2': '本利续存',
        '1': '存本转息',
        '0': '不续存'
      },
      CB_PRE_STATUS: {
        '0': '未通知',
        '1': '通知',
        '2': '已支取',
        '9': '取消'
      },
      //grb 增加查询类型
      GRB_QUERY_TYPE: {
        'A': '全部',
        'D': '支出',
        'C': '收入'
      },
      // grb 活期帐户类型
      GRB_ACCOUNT_STATUS: {
        'A': '激活',
        'I': '未激活',
        'C': '锁定',
        'D': '冻结'
      },
      // grb 交易方向
      GRB_TRANSFER_DERECTION: {
        'C': '转入',
        'D': '转出'
      },
      // grb 交易渠道
      GRB_TRANSFER_CHANNEL: {
        'TLR': '柜台',
        'PY': '汇款',
        'BSP': '自动',
        'EBCL': '网银'
      },
      // grb 交易类型
      GRB_TRANSFER_TYPE: {
        'OCT': '开立定期合约',
        'ROL': '定期合约滚续',
        'CLA': '账户关闭',
        'ERD': '定期合约提前销单',
        'FEE': '收费',
        'FRE': '到期结清',
        'FX': '外汇买卖',
        'INS': '派息',
        'ITX': '利息税',
        'RCR': '汇入汇款',
        'RCT': '冲正',
        'RDR': '汇出汇款',
        'RED': '冲正提前销单',
        'REV': '冲正',
        'TFD': '存入',
        'TFW': '支取',
        'TRW': '还款'
      },
      KYCC_CURRENCY_TYPE: {
        'USD': '美元'
      },
      GRB_CURRENCY_TYPE: {
        'USD': '美元',
        'CNY': '人民币',
        'CNH': '离岸人民币',
        'GBP': '英镑',
        'HKD': '港币',
        'KRW': '韩元',
        'SGD': '新加坡元',
        'CHF': '瑞士法郎',
        'JPY': '日元',
        'CAD': '加元',
        'AUD': '澳元',
        'EUR': '欧元',
        'DKK': '丹麦克朗',
        'NOK': '挪威克朗',
        'SEK': '瑞典克朗',
        'NZD': '新西兰元',
      },
      //开立电子账户
      GRB_CURRENCY_OPEN_TYPE: {
        'CNY': '人民币',
        'USD': '美元',
        'EUR': '欧元'
      },
      DEBITCREDIT_DERECTION: {
        '0': '转入',
        '1': '转出'

      },
      CB_ORDER_FLOW_STATE: {
        '': "全部",
        '90': "提交成功",
        '42': "交易成功",
        '99': "交易失败",
        '98': "状态未明"
      },
      CB_AUTH_ACTION_TYPE: {
        '0': "复核",
        '1': "授权",
        '2': "强制授权",
        '5': "删除",
        '6': "撤销",
        '9': "发送"
      },
      CB_AUTH_STATE: {
        '0': "正常",
        '1': "已提交待授权"
      },
      /* 管理员权限可以看到的功能列表（暂时） 2018.2.26  zangyukun*/
      /*暂时注释，等待修改，在下面写出新的一版*/
      CB_BSN_NAME: {
        '020101': "企业内部转账",
        '10200001': "下挂账号转账",
        '10200000': "同行汇款",
        '10200100': "行内批量转账",
        '10200300': "跨行汇款",
        '060201': "背书申请",
        '130201': "理财产品申购/认购",
        '130202': "理财产品赎回",
        '130203': "理财产品撤回",
        '13000101': "活期转定期",
        '13000102': "定期转活期",
        '13000301': "多帮利开立",
        '13000302': "多帮利支取",
        '13000201': "通知存款开立",
        '13000202': "通知存款预约支取",
        '13000203': "通知存款取消预约",
        '13000204': "通知存款支取",
        '13000104': "定期转出方式修改",
        '12000140': "外汇兑换"
      },

      /* 修改后的管理员权限可以看到的功能列表（暂时） 2018.2.27*/
      CB_BSN_NAME2: {
        //' ':"全部",
        '10700800': "操作员密码重置申请与审批", //管理员
        //'10100000':"账户信息查询", //查询操作，不记录操作日志
        //'10100100':"交易明细查询",  //查询操作，不记录操作日志
        '10101234': "新币种账户申请",
        '10200000': "同行汇款",
        '10200001': "下挂账号转账",
        '10200300': "跨行汇款",
        //'10200400':"同步交易状态",
        //'10200500':"收款人名册维护", //查询操作，不记录操作日志
        '12000110': "银企对账",
        '12000140': "外汇兑换",
        '13000101': "活期转定期",
        '13000102': "定期转活期",
        '13000104': "定期转出方式修改",
        '10700000': "操作员维护", //管理员
        '10700100': "登录密码修改", //管理员
        '10700500': "企业管理授权", //管理员
        '10700600': "账户维护" //管理员
      },
      /* 非管理员权限可以看到的功能列表（暂时） 2018.2.26  zangyukun*/
      CB_BSN_NAME1: {
        //			' ':"全部",
        //'10100000':"账户信息查询", //查询操作，不记录操作日志
        //'10100100':"交易明细查询",  //查询操作，不记录操作日志
        '10101234': "新币种账户申请",
        '10200000': "同行汇款",
        '10200001': "下挂账号转账",
        '10200300': "跨行汇款",
        //'10200400':"同步交易状态",
        //'10200500':"收款人名册维护", //查询操作，不记录操作日志
        '12000110': "银企对账",
        '12000140': "外汇兑换",
        '13000101': "活期转定期",
        '13000102': "定期转活期",
        '13000104': "定期转出方式修改"
      },
      CB_DEAL_TYPE: {
        // '13000101': "活期转定期",
        // '13000102': "定期转活期",
        // '13000104': "定期转出方式修改",
        '10200000': "同行汇款",
        // '10200001': "下挂账号转账",
        '10200300': "跨行汇款",
        // '12000140': "外汇兑换",
        '10101234': "新币种账户申请"
      },
      ORDER_STATUS: {
        //' ':'全部',
        '00': '等待复核',
        '01': '复核被拒绝',
        '02': '录入待授权',
        '05': '复核待授权',
        '11': '授权被拒绝',
        '42': '银行已受理',
        '50': '银行处理中',
        '90': '交易成功',
        '91': '交易被撤销',
        '92': '交易作废',
        '98': '交易可疑',
        '99': '交易失败',
        '10': '等待授权'
      },
      CB_AUTH_LVL: {
        '0': '无授权',
        '1': '一级',
        '2': '二级',
        '3': '三级',
        '4': '四级',
        '5': '五级'
      },
      DESPOSIT_TYPE: {
        '00': '活期存款',
        '10': '定期存款',
        '200': '活期存款',
        '201': '活期存款',
        '202': '通知存款',
        '205': '单位定期存款',
        '217': '信用卡存款',
        '221': '财政性存款',
        '222': '地方财政库款',
        '223': '待结算财政款项',
        '231': '同业活期存款',
        '234': '同业清算存款',
        '235': '同业一般存款',
        '236': '境外同业存放存款',
        '243': '应解汇款及临时存款',
        '251': '保证金',
        '261': '贷款',
        '262': '股票',
        '263': '基金',
        '264': '内部账户'
      },
      SAVING_PERIOD_TYPE: {
        '00': '活期',
        '03': '三个月',
        '06': '六个月',
        '12': '一年',
        '24': '两年',
        '36': '三年',
        '60': '五年'

      },
      CURRIDEN_TYPE: {
        '0': "现钞",
        '1': "汇款"
      },
      PAY_USE: {
        '贷款': '贷款',
        '采购款': '采购款',
        '工资': '工资',
        '借款': '借款',
        '往来款': '往来款',
        '采购款': '采购款',
        '还款': '还款',
        '差旅费': '差旅费',
        '保证金': '保证金',
        '运费': '运费'
      },
      AG_TYPE: {
        '1': '已签订',
        '2': '已撤销'
      },
      SIGN_TYPE: {
        '00': '柜台签约',
        '01': '网银签约'
      },
      CB_ORDER_STT: {
        '0': '相符',
        '1': '不相符',
        '2': '未对账'
      },
      CB_DEVIATION: {
        '0': '偏多',
        '1': '偏少',
        '2': '未对账'
      },
      BILL_TYPE: {
        '0000': "全部",
        'AC01': "银票",
        'AC02': "商票"
      },
      EBILL_ASSURE_Typ: {
        '01': "出票保证",
        '02': "承兑保证",
        '03': "背书保证"
      },
      EBILL_ASSURE_ANWSER_Typ: {
        '04': "出票保证应答",
        '05': "承兑保证应答",
        '06': "背书保证应答"
      },
      BILL_QUERY_TYPE: {
        '52': "承兑申请撤回",
        '54': "提示收票申请撤回",
        '55': "背书转让申请撤回",
        '56': "贴现申请撤回",
        '58': "质押申请撤回",
        '59': "（逾期）提示付款撤回",
        '51': "出票保证申请撤回",
        '53': "承兑保证申请撤回",
        '57': "背书保证申请撤回",
        '60': "追索通知撤回",
        '61': "同意清偿撤回"
      },
      BILL_TRAN_TYPE: {
        '01': "提示付款",
        '02': "逾期提示付款"
      },
      BILL_CLRFLG: {
        'SM00': "线上清算",
        'SM01': "线下清算"
      },
      BILL_DistTyp: {
        'RM00': "买断式",
        'RM01': "回购式"
      },
      BILL_RETFLG: {
        'SU00': "同意签收",
        'SU01': "拒绝签收"
      },
      CB_STATE: {
        '0': "正常",
        '1': "暂时冻结",
        '2': "冻结",
        '4': "维护中"
      },
      BILL_TRSFFLG: {
        'EM00': "可再转让",
        'EM01': "不得转让"
      },
      BILL_MSGSTATE: {
        'BW_000': "未发送",
        'BW_001': "待发送",
        'BW_002': "已发送",
        'BW_003': "人行已拒绝",
        'BW_004': "人行已确认",
        'BW_005': "发送失败"
      },
      pubPriv: {
        '0': "对公",
        '1': "对私"
      },
      cisborderOutside: {
        '1': "境内",
        '0': "境外"
      },
      feeTaker: {
        '0': "国内-我方",
        '1': "国外-对方"
      },
      accountState: {
        '0': "正常",
        '1': "挂失",
        '2': "口头挂失",
        '4': "冻结",
        '5': '销户'
      },
      CshFlg: {
        '0': "钞",
        '1': "汇"
      },
      AGENCY_TYPE: {
        '1041': "工资代发",
        '1006': "其他代发"
      },
      exchangeType: {
        '0': "结汇",
        '1': "购汇"
      },

      inOutFlag: {
        "0": "境外",
        "1": "境内"
      },
      isBackLc: {
        "Y": "是",
        "N": "否"
      },
      oppPartyClass: {
        "0": "对公",
        "1": "对私"
      },

      payeeType: {
        "": "全部",
        "0": "公有",
        "1": "私有"
      },
      chgUnderTaker: {
        "0": "国内-我方",
        "1": "国外-对方"
      },
      confirmInst: {
        "WITHOUT": "WITHOUT",
        "CONFIRM": "CONFIRM",
        "MAY ADD": "MAY ADD"
      },
      LGType: {
        "1": "BID　BOND",
        "2": "ADVANCE PAYMENT　GUARANTEE",
        "3": "PERFORMANCE　BOND",
        "4": "LOAN　GUARANTEE",
        "5": "PAYMENT　GUARANTEE",
        "6": "LEASING GUARANTEE",
        "7": "GUARANTEE FOR SPECIAL TRADE",
        "8": "OTHER KIND OF GUARANTEE"
      },
      isAgentLG: {
        "Y": "是",
        "N": "否"
      },
      furtherId: {
        "ISSUE": "ISSUE",
        "REQUEST": "REQUEST"
      },
      maturityFlag: {
        "Y": "有确定到期日",
        "N": "无确定到期日"
      },
      creditForm: {
        "IRREVOCABLE": "IRREVOCABLE",
        "REVOCABLE": "REVOCABLE",
        "IRREVOCABLE  TRANSFERABLE": "IRREVOCABLE  TRANSFERABLE",
        "REVOCABLE TRANSFERABLE": "REVOCABLE TRANSFERABLE",
        "IRREVOCABLE STANDBY": "IRREVOCABLE STANDBY",
        "IRREVOC TRANS STANDBY": "IRREVOC TRANS STANDBY"
      },
      applicableRule: {
        "UCP LATEST VERSION": "UCP LATEST VERSION",
        "EUCP LATEST VERSION": "EUCP LATEST VERSION",
        "EUCPURR LATEST VERSION": "EUCPURR LATEST VERSION",
        "ISP LATEST VERSION": "ISP LATEST VERSION"
      },
      PAY_TYPE: {
        '1': "支付协议",
        '2': "支付协议"
      },
      CstOblig: {
        "SHA": "SHA",
        "OUR": "OUR",
        "BEN": "BEN"
      },
      AgtBkFlg: {
        "N": "不是",
        "Y": "是",
        "T": "代他行"
      },
      TrdTyp: {
        "1": "贸易",
        "2": "非贸易",
        "3": "资本"
      },
      SubTxnTyp: {
        "1": "货到付款",
        "2": "预付货款",
        "3": "其他"
      },
      HxPayFlg: {
        "Y": "是",
        "N": "否"
      },
      PayType: {
        'TL01': "个人借记卡",
        'TL02': "个人贷记卡",
        'TL03': "单位银行结算账户"
      },
      recType: {
        'AT00': "单位银行结算账户",
        'AT01': "个人借记卡（存折）账户",
        'AT02': "个人贷记卡账户"
      },
      Query_TYPE: {
        '1': "授权查询协议",
        '2': "查询协议"
      },
      Clt_Acct: {
        '0': "全部账户",
        '1': "单一账户"
      },
      Clt_Typ: {
        '0': "子公司总余额",
        '1': "子公司可归集总金额"
      },
      Chase_Type: { //追索类型
        'RT00': "拒付追索",
        'RT01': "非拒付追索"
      },
      Chase_RsnCd: { //追索理由代码     非拒付追索时填写
        'RC00': "承兑人被依法宣告破产",
        'RC01': "承兑人因违法被责令终止活动"
      },
      groupTxnFlg: {
        '1': "归集",
        '2': "下拨"
      },
      CB_PERIOD: {
        '007': '7天',
        '101': '1个月',
        '103': '3个月',
        '106': '6个月',
        '112': '12个月',
        '124': '24个月',
        '136': '36个月'
      },
      CB_FIXED_PERIOD: {
        '0': '层层利',
        '1': '一天通知存款',
        '7': '七天通知存款',
        '3': '三个月',
        '6': '六个月',
        '12': '一年',
        '24': '两年',
        '36': '三年',
        '60': '五年'
      },
      CB_RATE: {
        '03': '2.60',
        '06': '2.80',
        '12': '3.00',
        '24': '3.75',
        '36': '4.25',
        '60': '4.75'
      },
      groupTxnStat: {
        'S': "成功",
        'F': "失败",
        'U': "状态未明"
      },
      BACK_TYPE: {
        'PR00': "已转发",
        'PR01': "待认证",
        'PR02': "已付款",
        'PR03': "已轧差",
        'PR04': "已清算",
        'PR05': "已成功",
        'PR06': "待处理",
        'PR07': "已处理",
        'PR08': "已撤销",
        'PR09': "已拒绝",
        'PR10': "已确认"
      },
      cashTransfer: {
        '1': "现金",
        '2': "转账"
      },
      Snd_Acct: {
        '0': "全部账户",
        '1': "单一账户"
      },
      Snd_Typ: {
        '0': "子公司总余额",
        '1': "子公司可归集总金额"
      },
      BILL_JFResCode: { //拒付理由代码
        'DC00': "与自己有直接债权债务关系的持票人未履行约定义务",
        'DC01': "持票人以欺诈、偷盗或者胁迫等手段取得票据",
        'DC02': "持票人明知有欺诈、偷盗或者胁迫等情形，出于恶意取得票据",
        'DC03': "持票人明知债务人与出票人或者持票人的前手之间存在抗辩事由而取得票据",
        'DC04': "持票人因重大过失取得不符合《票据法》规定的票据",
        'DC05': "超过提示付款期",
        'DC06': "被法院冻结或收到法院止付通知书",
        'DC07': "票据未到期",
        'DC08': "商业承兑汇票承兑人账户余额不足",
        'DC09': "其他（必须注明）"
      },
      channelFlg: {
        '00': "账务主机",
        '01': "ATM/CDM/CRS",
        '02': "ATM/CDM/CRS",
        '03': "POS",
        '04': "ATM/CDM/CRS",
        '05': "ATM/CDM/CRS",
        '06': "柜面",
        '07': "网银",
        '08': "手机银行",
        '09': "电话银行",
        '10': "其他",
        '11': "POS",
        '12': "柜面",
        '13': "ATM/CDM/CRS",
        '14': "POS",
        '15': "ATM/CDM/CRS",
        '16': "电话银行",
        '17': "网银",
        'W0': "新网银平台",
        'S0': "手机WAP",
        '18': "手机银行",
        '19': "ATM/CDM/CRS",
        '20': "电话银行",
        '21': "ATM/CDM/CRS",
        '22': "POS",
        '23': "ATM/CDM/CRS",
        '24': "POS",
        '25': "ATM/CDM/CRS",
        '26': "ATM/CDM/CRS",
        '27': "ATM/CDM/CRS",
        '28': "支付系统",
        '29': "柜面",
        '30': "国际结算",
        '31': "银联数据（贷记卡）",
        '32': "POS",
        '33': "POS",
        '34': "ATM/CDM/CRS",
        '35': "POS",
        '36': "ATM/CDM/CRS",
        '37': "POS",
        '38': "ATM/CDM/CRS",
        '39': "POS",
        '40': "ATM/CDM/CRS",
        '41': "POS",
        '42': "银联公共服务平台",
        '43': "ATM/CDM/CRS",
        '44': "ATM/CDM/CRS",
        '45': "ATM/CDM/CRS",
        '46': "ATM/CDM/CRS",
        '47': "ATM/CDM/CRS",
        '48': "ATM/CDM/CRS",
        '49': "ATM/CDM/CRS",
        '50': "ATM/CDM/CRS",
        '51': "POS",
        '52': "POS",
        '53': "POS",
        '54': "POS",
        '55': "POS",
        '56': "POS",
        '57': "POS",
        '58': "POS",
        '59': "ATM/CDM/CRS",
        '60': "POS",
        '61': "POS",
        '63': "其他",
        '65': "其他",
        '66': "其他",
        '67': "其他",
        '68': "其他",
        '80': "信贷",
        '82': "微贷",
        '83': "国结",
        '84': "财务",
        '85': "电子回单柜",
        '86': "理财管理系统",
        '87': "电票",
        '88': "网银",
        '9A': "村镇网银",
        '91': "网银",
        '92': "网银",
        '94': "网银",
        '97': "中间业务",
        '98': "中间业务",
        '99': "其他"
      },
      Account_Type: {
        '0': "收入账户",
        '1': "支出账户"
      },
      Loan_State: {
        '01': "正常",
        '02': "展期",
        '04': "逾期",
        '05': "呆滞",
        '06': "呆账",
        '07': "核销",
        '08': "销户"

      },
      Loan_Type: {
        '1': "普通",
        '2': "按揭"
      },
      ACCBANK_TYPE: {
        '0': "本行",
        '1': "他行"
      },
      LOG_BUSINESSNAME: {
        '0': "行内同名转账",
        '1': "行内转账",
        '2': "跨行转账"
      },
      CB_ACTION_TYPE: {
        '15': '修改账户限额',
        '17': '维护开通业务',
        '02': '修改用户基本信息',
        '03': '修改可操作账户列表',
        '04': '修改可操作业务列表',
        '11': '新增授权模式',
        '12': '修改授权模式',
        '13': '删除授权模式',
        '18': '开通业务维护',
        '16': '删除下挂账户'
      },
      BSNDEF_ACTION: {
        '10100000': "10100000_account_overview",
        '10100100': "10100100_account_query",
        '11000000': "11000000_intout_Account_input",
        '10100200': "10100200_trade_query",
        '10100300': "10100300_query",
        '10100500': "10100500_overdraft_Query",
        '10100600': "10100600_ChkCrd_Query",
        '10100700': "10100700_loan_input",
        '10200000': "10200000_inner_transfer",
        '10200001': "10200000_same_name_inner_transfer",
        '10200100': "10200100_batchTransfer",
        '10200200': "10200200_batch_transfer_query",
        '10200300': "10200300_outward_transfer",
        '10200400': "10200400_outward_transfer_query",
        '10200600': "10200600_turnBatchOutTransfer",
        '10200700': "10200700_batch_out_transfer_query",
        '10200900': "10200900_preTransferManage",
        '11000101': "11000101_intout_Account_input",
        '10300000': "10300000_agency",
        '10300100': "10300100_agency_salary",
        '10310000': "10310000_agency",
        '10310100': "10310100_agency_baoxiao",
        '10400000': "10400000_group_collection",
        '10400100': "10400100_group_down",
        '10400200': "10400200_limitCheck",
        '10400201': "10400201_turnManageLimit",
        '10400300': "10400300_query",
        '10400400': "10400400_groupQuery",
        '10400401': "10400401_groupAmtTransfer",
        '10400501': "10400501_groupTransferQuery",
        '10400601': "10400601_groupAutoTransfer",
        '10400602': "10400602_groupAutoTransferUpdate",
        '10400603': "10400603_groupAutoTransferQuery",
        '10600100': "106001_remit_app",
        '10600200': "10600200_currency_exchange_app",
        '10600400': "10600400_creditCard_app",
        '10600500': "10600400_creditCard_app_query",
        '10600600': "106006_guarantee_app",
        '10600700': "106006_guarantee_app_query",
        '10900000': "10900000_drawbill",
        '10900100': "10900100_presentmentAcceptance",
        '10900200': "10900200_BillEndorse_apply",
        '10900201': "10900201_BillEndorse_cancel",
        '10900300': "10900300_BillDiscount_Apply",
        '10900301': "10900301_BillDiscount_Cancel",
        '10900400': "10900400_billStoreCollQue",
        '10900401': "10900401_billStoreCollQueryCancle",
        '10900500': "10900500_AlertAssure",
        '10900600': "10900600_Prompt_Payment",
        '10900601': "10900601_Prompt_Cancel",
        '10900700': "10900700_Chase_Application",
        '10900701': "10900701_chaseUp_cancel",
        '10900702': "10900702_Agreement_Payoff",
        '10900704': "10900704_payOff_cancel",
        '10900900': "10900202_BillEndorse_Response",
        '10900800': "10900800_billQueryByState",
        '10900801': "10900801_billQueryByTrade",
        //网银互联
        '11000200': "11000200_agreement_pay_input_sign",
        '11000201': "11000201_agreement_pay_input",
        '11000300': "11000300_agreement_query_input_sign",
        '11000301': "11000301_agreement_query_input",
        '11000001': "11000001_business_status_query",
        //银企对账
        /*'12000100':"12000100_reconciliationManage",
        '12000101':"12000101_reconciliationQuery",
        '12000102':"12000102_reconciliationSign",
        '12000103':"12000103_reconciliationResultQuery",
        '12000110':"12000110_balanceReconciliation",
        '12000111':"12000111_statementQuery",
        '12000112':'12000112_transactionQuery',*/
        //投资理财
        //'13000101':'13000101_currentToFixed',
        '13000101': '13000101_currentToRegularInput', //修改了快捷方式活期转定期的跳转指令
        '13000102': '13000102_fixedToCurrent',
        '13000103': '13000103_investmentTransferQuery',
        '13000104': '13000104_fixedOutTypeRevise', //添加了快捷方式定期转出方式修改的跳转指令
        '13000201': '13000201_informDepositOpen',
        '13000202': '13000202_informWithdraw',
        '13000203': '13000203_informWithdrawCancel',
        '13000204': '13000204_informWithdrawTake',
        '13000205': '13000205_informOpenQuery',
        //客户服务
        '14000400': "14000400_leaveMessage",
        '10000700': "10000710_bankNotice",
        '10500004': "10500004_acc_operatableBal",
        '10000300': "10000300_custinfo_userDetail",
        '99992000': "99992000_CBLOG_QUERY",
        '10500204': "10500204_transferTemplateManage",
        '10200800': "10200800_transferPurpose",
        '10500003': "10500003_acc_aliasset",
        '10500006': "99991000_comm_func",
        '10500006': "99991000_comm_func",
        '10200500': "10200500_transfer_customer",
        '10500203': "10500203_userMainPageConfig",
        '10500005': "10500005_acc_sort",
        //电子对账
        '12000110': "12000110_balanceReconciliation",
        '12000120': "12000120_reconciliationDownload",
        '12000130': "12000130_balanceReconciliationQuery",

        '11000303': '11000303_agreement_query_input',
        '18000100': '18000100_scheduleLCW',
        '12000140': '12000140_foreignExchange',
        '10101234': '10101234_electronicAccountOpen',
        '10800000': '10800000_enterAuth',
        '11100000': '11100000_enterQuery'
      },

      CBK_CHANNEL_FLAG: {
        '0': '行内',
        '1': '跨行（实时）',
        '2': '跨行（普通/快捷）'
      },
      tran_flag: {
        '1': '快速',
        '2': '实时'
      },
      //返回错误信息系统标志
      ERRCODE_SYS_FLAG: {

        '002001': '核心',
        '025001': '基金',
        '017001': '卡前置',
        '017002': '卡前置（贷记卡）',
        '027001': '集团现金',
        '010001': '国结',
        '006002': '短信',
        '003002': '超级网银',
        '001001': 'ESB'

      },
      CB_BDF_TYPE: {
        '0': '普通交易',
        '1': '网银查询交易',
        '2': '付款录入交易',
        '3': '授权交易',
        '4': '代理业务录入交易',
        '5': '维护类交易',
        '6': '申请录入类交易',
        '9': '管理台交易',
        'S': '系统交易'
      },

      OrigBizCatgyCd: {
        '01': '借记',
        '02': '贷记',
        '03': '第三方贷记'
      },
      intInOrganName: {
        '01': 'Liana银行结算中心'
      },
      //本行行号
      BANKNO: {
        'inBankNo': '313261000018'
      },
      outTranStatus: {
        "1": "已登记",
        "2": "已复核",
        "3": "已发送",
        "4": "发送失败",
        "5": "滞留",
        "6": "已清算",
        "7": "排队",
        "8": "排队取消",
        "9": "人行拒绝排队撤销",
        "r": "人行拒绝",
        "k": "密押错",
        "m": "抹账",
        "h": "挂失",
        "j": "解挂"
      },
      //账户类型对应操作权限，0是所有账户类型，1是只有活期，将来扩展可以增加其他的条件，用于生成账户列表的时候按账户类型过滤账户
      //对应数据库字段是CB_ACC_INF.AIF_DEPOSITTYPE
      /*	201	活期存款
          202	通知存款
          205	单位定期存款
          217	信用卡存款
          221	财政性存款
          222	地方财政库款
          223	待结算财政款项
          234	同业清算存款
          235	同业一般存款
          236	境外同业存放存款
          243	应解汇款及临时存款
          251	保证金
      */
      CB_AccountType_Right: {
        '0': '00,10,200,201,202,205,217,221,222,223,231,234,235,236,243,251',
        '1': '00,201,200,231'
      },
      PAG_HISTORY: {
        'MT00': '签订',
        'MT02': '撤销'
      },
      CB_ReconSignType: {
        '0': '关闭',
        '1': '开通'
      },
      ReconAccount_Type: {
        '1': '重点账户',
        '2': '小额账户',
        '3': '普通账户'
      },
      CB_ReResult: {
        '2': '对账不符',
        '3': '对账相符'
      },
      CB_ReconResult: {
        '1': '尚未对账',
        '2': '对账不符',
        '3': '对账相符',
        '4': '余额未达核对后相符',
        '5': '余额不符'
      },
      Recon_State: {
        '0': '未回签',
        '1': '未回签',
        '2': '已回签',
        '3': '未回签',
        '4': '未回签',
        '5': '未回签',
        '6': '未回签'
      },
      CB_ReconType: {
        '1': '企业已收，银行未收',
        '2': '企业已付，银行未付',
        '3': '银行已收，企业未收',
        '4': '银行已付，企业未付'
      },
      CB_CDFlag: {
        '0': '借',
        '1': '贷'
      },
      Recon_result: {
        '0': '失败',
        '1': '成功'
      },
      Reconciliation_Result: {
        '0': '登记失败',
        '1': '登记成功'
      },
      LoanBase: {
        '01': '贷款本金',
        '02': '贷款本金',
        '03': '贷款本金',
        '04': '贷款本金',
        '10': '贷款利息',
        '11': '贷款利息',
        '20': '贷款利息',
        '21': '贷款利息',
        '51': '贷款复利',
        '52': '贷款复利',
        '53': '贷款罚息'
      },
      Statement_State: {
        '0': '未回复',
        '1': '线上相符',
        '2': '未达账相符',
        '3': '线上不相符',
        '4': '线下对账相符',
        '5': '待授权',
        '6': '授权拒绝'
      },
      CB_STATEMENT_STT: {
        '00': '无需对账',
        '01': '未对账',
        '02': '录入待复核',
        '03': '复核被拒绝',
        '04': '录入待授权',
        '05': '复核待授权',
        '06': '授权中',
        '07': '授权被拒绝',
        '08': '已撤销',
        '09': '等待发送',
        '10': '银行处理中',
        '11': '交易失败',
        '1': '对账完全相符',
        '2': '对账相符',
        '3': '对账不符',
        '4': '线下对账相符',
        '5': '待授权',
        '6': '授权被拒绝'
      },
      Statement_Subject: {
        '0': '定期存款',
        '1': '活期存款',
        '2': '贷款',
        '3': '保证金'
      },
      CB_SEASON: {
        '1': '首月',
        '2': '次月',
        '3': '末月'
      },
      CB_MONTH: {
        '01': '1月',
        '02': '2月',
        '03': '3月',
        '04': '4月',
        '05': '5月',
        '06': '6月',
        '07': '7月',
        '08': '8月',
        '09': '9月',
        '10': '10月',
        '11': '11月',
        '12': '12月'
      },
      CB_DAY: {
        '01': '1日',
        '02': '2日',
        '03': '3日',
        '04': '4日',
        '05': '5日',
        '06': '6日',
        '07': '7日',
        '08': '8日',
        '09': '9日',
        '10': '10日',
        '11': '11日',
        '12': '12日',
        '13': '13日',
        '14': '14日',
        '15': '15日',
        '16': '16日',
        '17': '17日',
        '18': '18日',
        '19': '19日',
        '20': '20日',
        '21': '21日',
        '22': '22日',
        '23': '23日',
        '24': '24日',
        '25': '25日',
        '26': '26日',
        '27': '27日',
        '28': '28日',
        '99': '月末'

      },
      CB_PAYTYPE: {
        '0': '年',
        '1': '季',
        '2': '月'
      },
      CB_ACC_TYPE: {
        '0': '其他',
        '1': '基本户',
        '2': '一般户',
        '3': '专用户',
        '4': '临时户'
      },
      CB_GROUP_OPTYPE: {
        '01': '修改划拨计划',
        '02': '删除划拨计划'
      },
      /*对账类型 ：余额对账，明细对账      2018.1.4 zangyukun*/
      CB_STATEMENT_TYPE: {
        '01': '余额对账',
        '02': '明细对账'
      },
      //add by dz begin 款项来源
      CB_PAY_SOURCE: {
        '0': '电汇',
        '1': '退回',
        '2': '系统内'
      },
      CB_CURRENCY_TYPE: {
        '01': '人民币',
        '12': '英镑',
        '13': '港币',
        '14': '美元'
      },
      CB_AUTOSAVETYPE: {
        '0': '等待客户指示',
        '2': '本金及利息续存',
        '5': '到期全部提取'
      },
      CB_PERIOD_FIXED: {
        '007': '7天',
        '101': '1个月',
        '103': '3个月',
        '106': '6个月',
        '112': '1年',
        '124': '2年',
        '136': '3年'
      },
      CB_RATESELECTION: {
        '0': '固定利率',
        '2': '随期浮动'
      },
      //grb新增需求修改短信模板  add by chenchao
      CB_SMS_MSG: {
        '0': '尊敬的用户:',
        '1': ',您此次登录企业网银系统短信验证码为',
        '2': '。【果仁宝】',
        '3': ',您此次修改定期转出方式的短信验证码为'
      },

      //grb新增需求重置密码状态  add by chenchao
      CB_RESET_PASSWORD: {
        '0': '申请中',
        '1': '审批通过',
        '2': '审批拒绝'
      },

      //grb新增需求证件类型  add by chenchao
      CERT_TYPE_GRB: {
        'ID': '身份证',
        'PP': '护照/证件类型',
        'CD': '中国居民身份证',
        'OT': '其他'
      },
      // grb 新增账户状态 add by zhaohr
      ACCT_STATUS: {
        '0': '未销户',
        '1': '已销户'
      },
      // grb 新增产品码 add by zhaohr
      PROUCT_NO: {
        'MMFCUD': '企业普通定期',
        'MMFIND': '个人普通定期'
      },
      Account_Type: {
        '0': '查询所有账号',
        '1': '查询活期账号',
        '2': '查询定期合约',
        '3': '查询货款合约',
        '4': '查询存放同业账号'
      },
      // grb 新增到期指示 add by zhaohr
      Renew_Flg: {
        '0': '等待客户指示',
        '1': '本金转期，利息支出',
        '2': '本金＋利息转期',
        '3': '本金＋利息＋部分新存入资金进行转期',
        '4': '本金＋利息 - 部分提取资金后进行转期',
        '5': '本金＋利息一起支出',
        '6': '本金＋利息开立本票'
      },
      Cash_Flag: {
        'S': '钞',
        'H': '汇'
      },
      Rate_Flag: {
        'Y': '年利率',
        'M': '月利率'
      },
      Regular_Account_State: {
        '01': 'ACTIVE',
        '02': 'UNSTART',
        '03': 'MATTURED',
        '04': 'REDEMPTION',
        '05': 'ROLLOVER',
        '06': 'OVERDUE',
        '07': 'BOOK IN DELETION'
      },
      //USBKey类型
      USBKEY_TYPE: {
        '001': '文件证书',
        '795': '飞天'
      },
      //USBKey证书状态
      KEY_CERT_STATE: {
        '0': '未激活',
        '1': '正常',
        '3': '未下载',
        '4': '激活',
        '5': '冻结',
        '6': '注销'
      },
      creditCurrencyType: {
        'USD': '美元',
        'HKD': '港币',
        'GBP': '英镑',
        'CNY': '人民币',
        'CHF': '瑞士法郎',
        'SGD': '新加坡元',
        'SEK': '瑞典克郎',
        'DKK': '丹麦克郎',
        'NOK': '挪威克郎',
        'JPY': '日元',
        'CAD': '加拿大元',
        'AUD': '澳大利亚元',
        'EUR': '欧元',
        'NZD': '新西兰元',
        'RUB': '卢布',
        'KRW': '韩元',
        'MYR': '马来西亚林吉特'
      },

      bankName: {
        "1": "中国工商银行",
        "2": "中国农业银行",
        "3": "中国建设银行",
        "4": "招商银行",
        "5": "中国银行",
        "6": "交通银行",
        "7": "中国邮政储蓄银行",
        "8": "中信银行",
        "9": "光大银行",
        "10": "民生银行",
        "11": "兴业银行",
        "12": "平安银行",
        "13": "北京银行",
        "14": "华夏银行",
        "15": "上海浦东发展银行",
        "16": "深圳发展银行",
        "17": "广东发展银行",
        "18": "上海银行",
        "19": "南京银行",
        "20": "宁波银行",
        "21": "江苏银行",
        "22": "渤海银行",
        "23": "恒丰银行",
        "24": "昆仑银行",
        "25": "大连银行",
        "26": "包头银行",
        "27": "浙商银行",
        "28": "杭州银行"
      },

      chargeFee: {
        "S": "共同-SHA"
      },
      payUseList: {
        // '/REC/RMTX/': '个人',
        '/REC/GODX/': "实物贸易",
        '/REC/STRX/': "服务贸易",
        '/REC/CTFX/': "资本投资",
        '/REC/OTFX/': "其他"
      }
    }
  }
}
